const LIBRARY_KEY = 'yomou_library';

function bookKey(id) { return `yomou_book_${id}`; }
function posKey(id)  { return `yomou_pos_${id}`; }

export function loadLibrary() {
  try {
    return JSON.parse(localStorage.getItem(LIBRARY_KEY) || '[]');
  } catch {
    return [];
  }
}

function saveLibrary(list) {
  localStorage.setItem(LIBRARY_KEY, JSON.stringify(list));
}

export function addBook(library, title, text) {
  const id = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  try {
    localStorage.setItem(bookKey(id), JSON.stringify({ title, text }));
  } catch {
    throw new Error('Book too large to save in browser storage');
  }
  const updated = [...library, { id, title, addedAt: new Date().toISOString() }];
  saveLibrary(updated);
  return { id, library: updated };
}

export function loadBookContent(id) {
  try {
    const raw = localStorage.getItem(bookKey(id));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function renameBook(id, newTitle, library) {
  const content = loadBookContent(id);
  if (content) {
    try {
      localStorage.setItem(bookKey(id), JSON.stringify({ ...content, title: newTitle }));
    } catch {}
  }
  const updated = library.map(b => b.id === id ? { ...b, title: newTitle } : b);
  saveLibrary(updated);
  return updated;
}

export function deleteBook(id, library) {
  localStorage.removeItem(bookKey(id));
  localStorage.removeItem(posKey(id));
  const updated = library.filter(b => b.id !== id);
  saveLibrary(updated);
  return updated;
}

export function savePosition(id, scrollY) {
  localStorage.setItem(posKey(id), String(Math.round(scrollY)));
}

export function loadPosition(id) {
  return parseInt(localStorage.getItem(posKey(id)) || '0', 10);
}
